import { Link } from 'gatsby';
import React from 'react';

import Tag from '_components/tag';
import { urlForArticle } from '_utils/articles';

export default function RelatedArticles({ articles }) {
  return (
    <div className="mt-8">
      <div className="text-lg sm:text-2xl font-bold text-content-primary md:mb-4 lg:mb-0">
        Related Articles
      </div>
      <div className="grid grid-cols-1 divide-y md:divide-y-0 md:grid-cols-3 lg:grid-cols-1 md:divide-x md:-mx-4 lg:mx-0 lg:divide-x-0 lg:divide-y">
        {articles.map((a) => (
          <Link
            key={a._id}
            className="py-4 md:py-0 md:px-4 lg:px-0 lg:py-4 text-content-primary hover:text-content-primary"
            to={urlForArticle(a)}
          >
            <div className="font-bold line-clamp-2">{a.title}</div>
            <div className="mt-2 line-clamp-2">{a.excerpt}</div>
            <div className="mt-2 flex gap-x-1">
              {a.tags_v3?.map((tag, index) => (
                <Tag key={index}>{tag.name}</Tag>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
